import { render } from "./AppEmployeeProfileCard.vue?vue&type=template&id=3bc57f16"
import script from "./AppEmployeeProfileCard.vue?vue&type=script&lang=js"
export * from "./AppEmployeeProfileCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__